(function(app) {

    app.provider("externalMarketingDollarApi",
    [
        function() {
            this.$get = [
                "externalsApiGateway", function (externalsApiGateway) {
                    var service = {};

                    service.getUserMarketingDollars = function(userId) {
                        return externalsApiGateway.get("/Users/" + userId + "/MarketingDollars");
                    }

                    return service;
                }
            ];
        }
    ]);
})(window.app); //jshint ignore:line